import React, { useState } from "react";
import {
  FaCalendarAlt,
  FaChevronLeft,
  FaChevronRight,
  FaMagic,
  FaTrashAlt,
} from "react-icons/fa";

const Step3Shifts = () => {
  const [viewMode, setViewMode] = useState("Week"); // Week, Month, List
  const [viewType, setViewType] = useState("Staff"); // Staff Member or Role

  // Mock staff data matching the UI image
  const initialStaffShifts = [
    {
      id: 1,
      name: "Ahmed Raza",
      role: "Head Chef",
      initials: "AR",
      bgColor: "bg-emerald-50 text-emerald-700 border-emerald-200",
      shifts: {
        Mon: {
          time: "08:00 - 16:00",
          dept: "Kitchen",
          sub: "Chef Duties",
          checks: 3,
        },
        Tue: {
          time: "08:00 - 16:00",
          dept: "Kitchen",
          sub: "Chef Duties",
          checks: 2,
        },
        Wed: {
          time: "08:00 - 16:00",
          dept: "Kitchen",
          sub: "Chef Duties",
          checks: 2,
        },
        Thu: {
          time: "08:00 - 16:00",
          dept: "Kitchen",
          sub: "Chef Duties",
          checks: 2,
        },
        Fri: { type: "OFF" },
        Sat: {
          time: "08:00 - 16:00",
          dept: "Kitchen",
          sub: "Chef Duties",
          checks: 2,
        },
        Sun: {
          time: "08:00 - 16:00",
          dept: "Kitchen",
          sub: "Chef Duties",
          checks: 2,
        },
      },
    },
    {
      id: 2,
      name: "Sara Khan",
      role: "Server",
      initials: "SK",
      bgColor: "bg-blue-50 text-blue-700 border-blue-200",
      shifts: {
        Mon: { time: "12:00 - 20:00", dept: "Front of House", checks: 2 },
        Tue: { time: "12:00 - 20:00", dept: "Front of House", checks: 2 },
        Wed: { type: "OFF" },
        Thu: { time: "12:00 - 20:00", dept: "Front of House", checks: 2 },
        Fri: { time: "12:00 - 20:00", dept: "Front of House", checks: 2 },
        Sat: { time: "12:00 - 20:00", dept: "Front of House", checks: 2 },
        Sun: { type: "OFF" },
      },
    },
    {
      id: 3,
      name: "John Smith",
      role: "Kitchen Assistant",
      initials: "JS",
      bgColor: "bg-amber-50 text-amber-700 border-amber-200",
      shifts: {
        Mon: { time: "08:00 - 16:00", dept: "Kitchen", checks: 2 },
        Tue: { time: "08:00 - 16:00", dept: "Kitchen", checks: 2 },
        Wed: { time: "08:00 - 16:00", dept: "Kitchen", checks: 2 },
        Thu: { type: "OFF" },
        Fri: { time: "08:00 - 16:00", dept: "Kitchen", checks: 2 },
        Sat: { type: "OFF" },
        Sun: { time: "08:00 - 16:00", dept: "Kitchen", checks: 2 },
      },
    },
  ];

  const days = [
    { label: "Mon", date: "01 May" },
    { label: "Tue", date: "02 May" },
    { label: "Wed", date: "03 May" },
    { label: "Thu", date: "04 May" },
    { label: "Fri", date: "05 May" },
    { label: "Sat", date: "06 May" },
    { label: "Sun", date: "07 May" },
  ];

  const coverage = {
    Mon: "5/5",
    Tue: "5/5",
    Wed: "5/5",
    Thu: "3/5",
    Fri: "5/5",
    Sat: "5/5",
    Sun: "5/5",
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
      {/* Step Header */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-md bg-blue-600 flex items-center justify-center text-white font-bold">
            3
          </div>
          <div>
            <h2 className="text-lg font-semibold text-gray-900">
              Assign Shifts & Checks
            </h2>
            <p className="text-xs text-gray-500">
              Set working hours, assign checks and responsibilities for each
              day.
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2 self-end">
          <button className="flex items-center gap-2 px-3 py-1.5 border border-blue-200 text-blue-600 rounded-md text-sm font-medium hover:bg-blue-50 transition">
            <FaMagic size={12} /> Auto Fill Shifts
          </button>
          <button className="flex items-center gap-2 px-3 py-1.5 border border-red-200 text-red-600 rounded-md text-sm font-medium hover:bg-red-50 transition">
            <FaTrashAlt size={12} /> Clear All
          </button>
        </div>
      </div>

      {/* Grid Filter Toolbar */}
      <div className="flex flex-col md:flex-row justify-between items-center bg-slate-50 p-3 rounded-t-lg border-x border-t border-gray-200 gap-3">
        <div className="flex items-center gap-4 w-full md:w-auto">
          <div>
            <label className="block text-[10px] uppercase font-bold text-gray-400 mb-0.5">
              View by
            </label>
            <select
              value={viewType}
              onChange={(e) => setViewType(e.target.value)}
              className="text-xs p-1.5 border border-gray-300 rounded bg-white font-medium focus:outline-none"
            >
              <option value="Staff">Staff Member</option>
              <option value="Role">Role Hierarchy</option>
            </select>
          </div>
          <div className="flex items-center gap-1 border border-gray-300 rounded p-1 bg-white shadow-sm mt-4 text-xs font-medium text-gray-700">
            <FaCalendarAlt className="text-gray-400 mx-1" />
            <span>01 May 2026 - 31 May 2026</span>
          </div>
        </div>

        {/* Calendar Nav & View Selector */}
        <div className="flex items-center gap-4 w-full md:w-auto justify-between md:justify-end">
          <div className="flex items-center gap-1 border border-gray-300 rounded bg-white p-1">
            <button className="p-1 hover:bg-gray-100 rounded text-gray-600">
              <FaChevronLeft size={10} />
            </button>
            <button className="px-2 py-0.5 text-xs font-medium hover:bg-gray-100 rounded">
              Today
            </button>
            <button className="p-1 hover:bg-gray-100 rounded text-gray-600">
              <FaChevronRight size={10} />
            </button>
          </div>

          <div className="flex border border-gray-300 rounded overflow-hidden">
            {["Week", "Month", "List"].map((mode) => (
              <button
                key={mode}
                onClick={() => setViewMode(mode)}
                className={`px-3 py-1 text-xs font-medium transition ${viewMode === mode ? "bg-blue-600 text-white" : "bg-white text-gray-600 hover:bg-gray-50"}`}
              >
                {mode}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Rota Management Grid Table */}
      <div className="overflow-x-auto border border-gray-200">
        <table className="min-w-full table-fixed border-collapse divide-y divide-gray-200 text-left">
          <thead className="bg-slate-100 text-[11px] font-semibold text-gray-500 uppercase tracking-wider">
            <tr>
              <th className="w-48 p-3 border-r border-gray-200 bg-slate-100 sticky left-0 z-10">
                Staff Member
              </th>
              {days.map((day, idx) => (
                <th
                  key={idx}
                  className="p-2 border-r border-gray-200 text-center min-w-[120px]"
                >
                  <div className="text-gray-400 font-medium">{day.label}</div>
                  <div className="text-gray-800 font-bold">{day.date}</div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200 text-xs">
            {initialStaffShifts.map((staff) => (
              <tr key={staff.id} className="hover:bg-slate-50 transition">
                {/* Staff Member Card Column */}
                <td className="p-3 border-r border-gray-200 font-medium sticky left-0 bg-white shadow-[2px_0_5px_-2px_rgba(0,0,0,0.05)] z-10">
                  <div className="flex items-center gap-2">
                    <div className="w-7 h-7 rounded-full bg-blue-100 text-blue-700 font-bold flex items-center justify-center text-[10px]">
                      {staff.initials}
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900">
                        {staff.name}
                      </div>
                      <div className="text-[10px] text-gray-400 font-normal">
                        {staff.role}
                      </div>
                    </div>
                  </div>
                </td>

                {/* Days Schedule Cards Row */}
                {days.map((day, idx) => {
                  const shift = staff.shifts[day.label];
                  return (
                    <td
                      key={idx}
                      className="p-2 border-r border-gray-200 align-middle"
                    >
                      {shift?.type === "OFF" ? (
                        <div className="text-center text-gray-400 font-bold py-4 uppercase bg-gray-50 rounded tracking-wider border border-dashed border-gray-200">
                          Off
                        </div>
                      ) : (
                        <div
                          className={`p-2 rounded border transition text-center ${staff.bgColor} shadow-sm`}
                        >
                          <div className="font-bold text-[11px]">
                            {shift.time}
                          </div>
                          <div className="text-[10px] opacity-80 mt-0.5">
                            {shift.dept}
                          </div>
                          {shift.sub && (
                            <div className="text-[9px] opacity-70 italic">
                              {shift.sub}
                            </div>
                          )}
                          <div className="mt-1 inline-block bg-white/70 px-1.5 py-0.5 rounded text-[9px] font-semibold border border-black/5">
                            Checks: {shift.checks}
                          </div>
                        </div>
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}

            {/* Daily System Coverage Overview Row */}
            <tr className="bg-slate-50 font-semibold text-gray-700">
              <td className="p-3 border-r border-gray-200 text-right sticky left-0 bg-slate-50 z-10 text-[11px] uppercase tracking-wider text-gray-500">
                Daily Coverage
              </td>
              {days.map((day, idx) => {
                const statusColor =
                  coverage[day.label] === "3/5"
                    ? "text-red-500 bg-red-50 border-red-100"
                    : "text-emerald-600 bg-emerald-50 border-emerald-100";
                return (
                  <td
                    key={idx}
                    className="p-2 border-r border-gray-200 text-center"
                  >
                    <span
                      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-bold border ${statusColor}`}
                    >
                      <span className="w-1.5 h-1.5 rounded-full bg-current" />
                      {coverage[day.label]}
                    </span>
                  </td>
                );
              })}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Step3Shifts;
